import React from 'react';

import { useApp } from '../store/AppContext';
import PasswordForm from './PasswordForm';
import PasswordRecoveryCard from './passwordRecoveryScreen/PasswordRecoveryCard';

export default function PasswordRecoveryScreen() {
  const { recoveryType } = useApp();
  const invite = recoveryType === 'invite';
  return (
    <div className="flex items-center justify-center h-[100vh] bg-[#f5f4f2]">
      <PasswordRecoveryCard invite={invite} />
    </div>
  );
}
